import { createContext } from "react";
import { BaamerFileRevisionDto } from "@/models/interfaces/dtos/baamer-file-revision-dto.ts";
import { StoreyTypologyType } from "@/models/types/storey-typology-type";
import FileType from "@/models/enums/file-type";

import ProjectOrganisation from "./models/project-organisation";
import PlanFileData from "../project-measure/models/plan-file-data";
import SetupFileStoreyData from "./models/setup-file-data";
import FileData3D from "./models/file-data-3d";
import ValidationResult from "@/models/types/validation-result.ts";

export type FileStoreyData = { fileId: string, fileName: string, storeyName: string, data: PlanFileData };

export interface ProjectOrganisationContextProps {
    isLoading: boolean;
    data: ProjectOrganisation | undefined;
    baamerFileRevisions: BaamerFileRevisionDto[] | undefined;
    isDirty: boolean;
    isSaving: boolean;

    tryAddBuilding: (name: string) => void;
    tryEditBuilding: (buildingId: string, name: string) => void;
    removeBuilding: (buildingId: string) => void;

    tryAddStorey: (buildingId: string, name: string, altimetry: number, storeyType: StoreyTypologyType) => void;
    tryEditStorey: (buildingId: string, storeyId: string, newName?: string, newAltimetry?: number, storeyType?: StoreyTypologyType) => void;
    removeStorey: (buildingId: string, storeyId: string) => void;

    setupFiles: (files: SetupFileStoreyData[]) => void;
    addFile: (scope: ("project" | "building" | "storey"), fileType: FileType, fileId: string, fileName: string, revision: number, relativePath: string, fileMetaObject: string, buildingId?: string, storeyId?: string) => void;
    removeFile: (scope: ("project" | "building" | "storey"), fileType: FileType, fileId: string, buildingId?: string, storeyId?: string) => void;

    getAllPlanFilesData: () => Array<FileStoreyData>;
    getPlanFileData: (storeyId: string | undefined, fileId: string | undefined) => PlanFileData | undefined;
    setPlanFileData: (storeyId: string, fileId: string, updatedFileData: PlanFileData) => void;
    removePlanFileData: (storeyId: string, fileId: string) => void;

    getAll3dFilesData: () => Array<FileData3D>;

    tryAddPendingFile: (fileId: string, file: File, scope: ("project" | "building" | "storey"), buildingId?: string, storeyId?: string) => void;
    removePendingFile: (fileId: string) => void;

    canSaveChanges: (projectData: ProjectOrganisation) => ValidationResult;
    appendRoofs: (projectData: ProjectOrganisation) => ProjectOrganisation;
    saveChanges: (projectData: ProjectOrganisation) => Promise<void>;

    getBaamerFileRevisionIdFromStoreyId: (storeyId: string) => string | undefined;
    getBaamerFileRevisionIdFromFileId: (fileId: string) => string | undefined;

    invalidateProjectReferences: () => Promise<void>;
}

export const ProjectOrganisationContext = createContext<ProjectOrganisationContextProps | undefined>(undefined);